// Enums
import { dtoState } from '../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicates } from './useCriteriaStorePredicates';

/**
 * Filters Deleted predicates from an array of UUIDs
 * @param {[string]} uuids
 * @returns {[string]}
 */
export const useCriteriaStoreNonDeletedPredicateUuids = (uuids = []) => {
    const predicates = useCriteriaStorePredicates(uuids);

    return uuids.filter((uuid) =>
        (predicates ?? []).some((predicate) => uuid === predicate.uuid && predicate.dtoState !== dtoState.Deleted)
    );
};
